import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { materialModules } from 'src/shared/material.module';
interface EVAFeedbackFormControls {
  feedbackCtrl: FormControl<string>;
}

@Component({
  selector: 'ez-eva-negative-feedback-modal',
  imports: [
    ReactiveFormsModule,
    materialModules,
  ],
  templateUrl: './eva-negative-feedback-modal.component.html',
  styleUrl: './eva-negative-feedback-modal.component.scss',
})
export class EvaNegativeFeedbackModalComponent implements OnInit {
  protected evaFeedbackForm: FormGroup<EVAFeedbackFormControls>;

  readonly #dialogRef = inject(MatDialogRef<EvaNegativeFeedbackModalComponent>);

  ngOnInit(): void {
    this.evaFeedbackForm = new FormGroup<EVAFeedbackFormControls>({
      feedbackCtrl: new FormControl<string | null>(null),
    });
  }

  submitFeedback(): void {
    this.#dialogRef.close(this.evaFeedbackForm.controls.feedbackCtrl.value);
  }
}
